import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Mentions from 'rc-mentions';
import AppContext from '../AppContext';

class TextareaField extends Component {
  constructor(props) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    this.props.context.focusMessageInput();
  }

  onChangeHandler(val) {
    this.props.onChange(val);
  }

  handleKeyPress(e) {
    if (
      e.key === 'Enter' &&
      e.shiftKey === false &&
      this.props.checkValidMessage(this.props.value)
    ) {
      e.preventDefault();
      this.props.sendChatMessage(e);
    }
  }

  render() {
    const { Option } = Mentions;

    return (
      <Mentions
        placeholder={this.props.placeholder}
        className="chat-editor__textarea"
        value={this.props.value}
        onChange={this.onChangeHandler}
        onKeyPress={this.handleKeyPress}
      >
        {this.props.data.map(user => (
          <Option key={user.id} value={user.display}>
            {user.display}
          </Option>
        ))}
      </Mentions>
    );
  }
}

TextareaField.defaultProps = {
  value: '',
  placeholder: '',
};

TextareaField.propTypes = {
  context: PropTypes.shape({
    connected: PropTypes.bool,
    currentUserAvatar: PropTypes.string,
    currentUserId: PropTypes.number,
    currentUserName: PropTypes.string,
    laymanMode: PropTypes.bool,
    tenant: PropTypes.string,
    messageInputRef: PropTypes.shape({}),
    focusMessageInput: PropTypes.func,
    isAlien: PropTypes.bool,
  }).isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checkValidMessage: PropTypes.func.isRequired,
  sendChatMessage: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      display: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

const TextareaFieldWithContext = props => (
  <AppContext.Consumer>
    {context => <TextareaField context={context} {...props} />}
  </AppContext.Consumer>
);

export default TextareaFieldWithContext;
